import "../../../src/App.css";
import Charges from "../../components/Charges/Charges";
import AddCharges from "../../components/AddCharges/AddCharges";
import ChargesList from "../../components/ChargesList/ChargesList";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function ChargesMaster() {

  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const title = "Add Charges";
  const heading = "Charges List";
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios.get(`${baseAPI}adminget/GETUserDetail`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        //console.log(response.data.data);
        setUserDetailResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
    }
  }, []);

  //console.log(userDetailResponse);

  return (
    <>
      <div className="d-flex flex-row app">
      <MiniDrawer />
      <div className="container-fluid" style={{padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4"}}>
          <div                                   
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                   Charges Master| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
              <MasterTopButtons title={title} heading={heading} setOpenAddProfile = {setOpenAddProfile} openAddProfile={openAddProfile}/>
         {openAddProfile? <AddCharges/> : null}
         {openProfile? <Charges/> : null}
         <ChargesList userDetailResponse={userDetailResponse} setOpenProfile = {setOpenProfile} openProfile={openProfile} />
         <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChargesMaster;
